// nodeIcons.js
import {
    Type,
    ArrowRightCircle,
    ArrowLeftCircle,
    FileText,
    Filter,
    GitMerge,
    GitBranch,
    Terminal,
    Cpu
} from 'lucide-react';

export const NodeIcons = {
    customInput: ArrowRightCircle,
    customOutput: ArrowLeftCircle,
    llm: Cpu,
    text: Type,
    filter: Filter,
    transform: GitBranch, // or maybe Settings/Sliders
    combine: GitMerge,
    condition: GitBranch,
    print: Terminal,
    default: FileText,
};
